/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================
*/

// Material Dashboard 2 React base styles
import typography from "assets/theme/base/typography";
import pxToRem from "assets/theme/functions/pxToRem";

const { size } = typography.size ? typography : { size: {} };

const dialogTitle = {
  styleOverrides: {
    root: {
      fontSize: size?.md || pxToRem(18),
      fontWeight: 600,
      lineHeight: 1.4,
      marginBottom: pxToRem(4),
    },
  },
};

export default dialogTitle;
